import React from "react";

import "./Accreditation.css";
import DSIR from "../../assets/DSIR.png";
import ISO from "../../assets/ISO.png";
import ISO1 from "../../assets/ISO1.png";
import QUA from "../../assets/certified.png";
const Accreditation = () => {
  const accreditations = [
    { img: ISO, title: "ISO " },
    { img: ISO1, title: "ISO1" },
    { img: DSIR, title: "DSIR" },
    { img: QUA, title: "QUA" },
  ];

  return (
    <div className="accreditation-container">
      <h2 className="accreditation-title">Accreditation</h2>
      <div className="accreditation-divider"></div>
      <div className="accreditation-grid">
        {accreditations.map((item) => (
          <div key={item.title} className="accreditation-card">
            <img
              src={item.img}
              alt={item.title}
              className={`accreditation-image ${
                item.title.trim() === "QUA" ? "ISO_9001_2015_img" : ""
              }`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Accreditation;
